import React, { useEffect, useState } from "react";
import VimeoEmbed from "@u-wave/react-vimeo";
import BlockContent from "@sanity/block-content-to-react";
import { buildFileUrl } from "@sanity/asset-utils";
import { dataset, fileUrlFor, projectId, urlFor } from "../../utils/utils";
import ReactLottie from "lottie-react";
import plugins from "../../assets/lottie/plugins.json";
import helmet from "../../assets/lottie/helmet.json";
import rocketStable from "../../assets/lottie/rocket-stable.json";

import "./video.scss";
import cn from "classnames";

interface IProps {
  title?: string;
  asset: {
    _ref: string;
  };
  file: {
    asset: {
      _ref: string;
    };
  };
  image: {
    asset: {
      _ref: string;
    };
  };
  preset?: string;
  // fullSize: boolean;
  // noShadow: boolean;
  //   url: string;
  //   body?: any;
}

export const Lottie = (props: IProps) => {
  // console.log("VIDEOOO", props);
  // const idElements = props.asset._ref.split("-");

  // const idElements = props.file?.asset._ref.split("-") || ["", ""];
  // const url = `https://cdn.sanity.io/files/${projectId}/${dataset}/${idElements[1]}.${idElements[2]}`;

  // const [json, setJSON] = useState("");
  // useEffect(() => {
  //   fetch(url)
  //     .then((res) => res.json())
  //     .then((res) => setJSON(res));
  //   console.log(url);
  // }, []);
  return (
    <div>
      {globalThis.document && (
        <div
          className={cn("video--container", {
            // "video--container--full": props.fullSize,
            // "video--no-shadow": props.noShadow === true,
          })}
        >
          {/* CORS errors locally, for now use baked animations */}
          {/* {json && <ReactLottie animationData={json} loop={true} />} */}
          {props.preset === "plugins" && (
            <ReactLottie animationData={plugins} loop={true} />
          )}
          {props.preset === "helmet" && (
            <ReactLottie animationData={helmet} loop={true} />
          )}
          {props.preset === "rocket-stable" && (
            <ReactLottie animationData={rocketStable} loop={true} />
          )}
          {/* {props.preset === "transponder" && (
            <ReactLottie animationData={rocketStable} loop={true} />
          )} */}
          <img
            src={(props.image && urlFor(props.image).url()) || ""}
            loading="lazy"
            alt={props.title}
          />
        </div>
      )}
      {/* <div className="vimeo--text">
        {body && <BlockContent blocks={body} />}
      </div> */}
    </div>
  );
};
